@if (loader) {
<ap-loading [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading>
}
<div class="modal-header">
    <h3 class="modal-title">
        Dataflow Mapping Changes
        <i (click)="cancel()" class="fa fa-times pull-right" style="cursor: pointer;"></i>
        <i class="fa pull-right" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
           style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    </h3>
</div>
<div class="modal-body" [hidden]="minimise">
    <div class="mainContainer">
        <div style="width: 97.5% !important" class="card m-3">
            <div class="card-body">
                <form [formGroup]="form" novalidate>
                    <div class="container">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <ap-field [title]="'Tax Year'" [fieldId]="'TAX_YEAR'" [disabled]="true">
                    <input appkit-field formControlName="TAX_YEAR"  aria-label="Tax year" />
                                    </ap-field>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <ap-field [title]="'Identifier'" [fieldId]="'IDENTIFIER'" [disabled]="true">
                    <input appkit-field formControlName="IDENTIFIER"  aria-label="Identifier" />
                                    </ap-field>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <ap-field [title]="'Item Code'" [fieldId]="'ITEM_CODE'">
                    <input appkit-field formControlName="ITEM_CODE"  aria-label="Item code" />
                                    </ap-field>
                                </div>
                                <div class="form-group">
                                    <ap-field [title]="'Item Sub Code'" [fieldId]="'ITEM_SUB_CODE'">
                    <input appkit-field formControlName="ITEM_SUB_CODE"  aria-label="Item sub code" />
                                    </ap-field>
                                </div>
                                <div class="form-group">
                                    <ap-field [styleClass]="'large-textbox'" [title]="'Item Description'" [fieldId]="'ITEM_DESCRIPTION'">
                    <input appkit-field formControlName="ITEM_DESCRIPTION"  aria-label="Item description" />
                                    </ap-field>
                                </div>

                                <div class="form-group">
                                    <ap-field [title]="'Line Grouping'" [fieldId]="'LINE_GROUPING'">
                    <input appkit-field formControlName="LINE_GROUPING"  aria-label="Line grouping" />
                                    </ap-field>
                                </div>
                                <div class="form-group">
                                    <ap-field [title]="'Line Number'" [fieldId]="'LINE_NUMBER'">
                    <input appkit-field formControlName="LINE_NUMBER"  aria-label="Line number" />
                                    </ap-field>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
<div class="a-modal-footer modal-footer pad-zero" style="float: right; display: flex; justify-content: flex-end; width: 100%;">

    <ap-button [label]="'CANCEL'" class="ap-mr-spacing-3"
        [btnType]="'primary'" (onClick)="cancel()">
    </ap-button>
    <div>
        <ap-button [label]="'SAVE'" class="ap-mr-spacing-3" [btnType]="'primary'"
            (onClick)="save()"></ap-button>
    </div>

</div>
